import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const getCertificatePageContext = React.createContext({});
export let getCertificatePageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMGetCertificate = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getCertificatePageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getCertificatePageMachine);

  return {
    getCertificatePageMachine,
    getCertificatePageState: state,
    getCertificatePageSend: send,
  };
};
